export enum MessageStatus {
  NotInitiated,
  Started,
  Success,
  Failed,
}
